module.exports = __webpack_public_path__ + "static/images/38ad9a23.gif";